"use client"

import React from "react";
import EmblaCarousel from "./Carousel/EmblaCarousel";
import EmbedVideo from "./valueprop/EmbedVideo";
import RotatedCardValueProps from "./valueprop/RotatedCardValueProps";
import DailyDeals from "../Deals/DailyDeals";
import MessageValueProp from "./valueprop/MesssageValueProp";


export default function ValueProp(props) {
    const {vpConfig: config, id, dailyDeals} = props

    const sectionClass = config?.sectionClass || ""

    return (
        <section key={`process-${id}`} className={`our-best-features-wrapper section-padding ${sectionClass}`}>
            <div className="container">
                {(() => {
                    if (config?.gallery === true) {
                        return (
                            <EmblaCarousel {...props} options={{dragFree: true, loop: true}}/>
                        );
                    }

                    if (config?.embedVideo === true) {
                        return <EmbedVideo {...props}/>
                    }

                    if (config?.type === "rotated-cards") {
                        return <RotatedCardValueProps {...props}/>;
                    }

                    if (config?.type === "infinite-slider") {
                        return(
                            <>
                                {dailyDeals && <DailyDeals {...props} dailyDeals={dailyDeals} />}
                            </>
                        )
                    }

                    return <MessageValueProp {...props}/>
                })()}
            </div>
        </section>)
}




